import React, { useCallback, useEffect, useRef } from 'react';

function ApplyModal({ open, targetUrl, mobile, onClose }) {
  const confirmRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    document.body.style.overflow = 'hidden';
    confirmRef.current?.focus();
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);

  const handleConfirm = useCallback(() => {
    const target = targetUrl;
    const isMobile = mobile;
    onClose();
    if (!target) return;
    if (isMobile) {
      window.location.assign(target);
    } else {
      window.open(target, '_blank', 'noopener,noreferrer');
    }
  }, [targetUrl, mobile, onClose]);

  if (!open) return null;

  return (
    <div className="apply-modal" id="apply-modal">
      <div
        className="apply-modal-backdrop"
        data-modal-close
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className="apply-modal-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="apply-modal-title"
        aria-describedby="apply-modal-message"
      >
        <h2 id="apply-modal-title">投递提示</h2>
        <p id="apply-modal-message">首次点击需登录猎聘账号后申请岗位</p>
        <div className="apply-modal-actions">
          <button className="apply-modal-close" type="button" onClick={onClose}>
            关闭
          </button>
          <button
            ref={confirmRef}
            className="apply-modal-confirm"
            type="button"
            onClick={handleConfirm}
          >
            直接跳转
          </button>
        </div>
      </div>
    </div>
  );
}

export default ApplyModal;
